<template>
    <div class="signup">

        <div class="card">
            <div class="card-header">
                <h5 class="card-title text-center">Signup</h5>
                <hr>
            </div>
            <div class="card-body">

                <div class="d-flex justify-content-center">
                    <div class="d-flex justify-content-around step-wrapper">
                        <span>Personal Details</span>
                        <span>Company Details</span>
                    </div>
                </div>
                <div class="d-flex justify-content-center">
                    <StepIndicator v-model="showCompanyForm" />
                </div>

                <transition-group :name="transitionType"
                                  tag="div"
                                  class="slider-transition">
                    <div class="step" v-if="!showCompanyForm" :key="1">
                        <div class="row mb-2">
                            <BasicTextInput class="col-6" label="First Name"
                                            placeholder="First Name"
                                            :validator="$v.user.firstName"
                                            :validatorMsgMap="validatorMsgMapBase"
                                            v-model="user.firstName" />
                            <BasicTextInput class="col-6" label="Last Name"
                                            placeholder="Last Name"
                                            :validator="$v.user.lastName"
                                            :validatorMsgMap="validatorMsgMapBase"
                                            v-model="user.lastName"  />
                        </div>

                        <BasicTextInput class="mb-2" label="Email"
                                        placeholder="Email"
                                        :validator="$v.user.email"
                                        :validatorMsgMap="validatorMsgMapBase"
                                        v-model="user.email"
                                        type="email" />
                        <div class="row mb-2">
                            <PhoneNumberInput  class="col-6" label="Phone"
                                               placeholder="Phone"
                                               :validator="$v.user.phone"
                                               :validatorMsgMap="validatorMsgMapBase"
                                               v-model="user.phone"    />
                            
                            <!-- <input type="text" id="Username" style="position:fixed; z-index: -5"/> -->
                            <BasicTextInput class="col-6" label="Password"
                                            placeholder="Password"
                                            :validator="$v.user.password"
                                            :validatorMsgMap="passwordMsgMap"
                                            v-model="user.password"
                                            type="password" />
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="sales-help-wrapper p-2">
                                    <Checkbox label="I would like to be contacted by SmartSales representative." v-model="requestsSalesHelp"/>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="terms-wrapper p-2">
                                    <span>By choosing to signup, I agree to the SmartSales terms and conditions.</span>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="step" v-if="showCompanyForm" :key="2">
                        <BasicTextInput class="mb-2" label="Company Name"
                                        placeholder="Company Name"
                                        :validator="$v.company.name"
                                        :validatorMsgMap="validatorMsgMapBase"
                                        v-model="company.name"    />
                        <BasicTextInput class="mb-2"       label="Website" placeholder="Website" v-model="company.website" />
                        <div class="mb-2 row">
                            <BasicTextInput  class="col-8" label="Address" placeholder="Address" v-model="company.addr1"   />
                            <BasicTextInput  class="col-4" label="Suite"   placeholder="Suite"   v-model="company.addr2"   />
                        </div>
                        <div class="mb-2 row">
                            <BasicTextInput class="col-4" label="City"     placeholder="City"     v-model="company.city"           />
                            <StateSelect    class="col-4" label="State"    placeholder="State"    v-model.number="company.stateId" />
                            <ZipCodeInput   class="col-4" label="Zip Code" placeholder="Zip Code" v-model="company.zip"            />
                        </div>
                    </div>
                </transition-group>

                <button class="btn btn-primary btn-block" @click="signup">Signup</button>
            </div>
        </div>
        <modal ref="signupConfirmationModal">
            <div class="card">
                <div class="card-header">
                    <h5>Signup Successful</h5>
                    <hr>
                </div>
                <div class="card-body">
                  <p>You have been sent a confirmation email. Please login via the link in the confirmation email to complete the signup process.</p>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import StepIndicator           from '@/components/StepIndicator.vue';
    import Modal                   from '@/components/Modal.vue';

    import { SignupService }           from '@/services';

    import {
        required,
        minLength,
        email,
        helpers
    }                              from 'vuelidate/lib/validators';
    import { validatorMsgMapBase } from "@/modules/helpers";

    const hasDigit           = helpers.regex('hasDigit', /\d/);
    const hasUppercase       = helpers.regex('hasUppercase', /[A-Z]/);
    const hasNonAlphanumeric = helpers.regex('hasNonAlphanumeric', /\W/);

    export default {
        name: "Signup",
        data: () => {
            return {
                validatorMsgMapBase: validatorMsgMapBase,
                showCompanyForm: false,
                user:    defaultUser(),
                company: defaultCompany(),
                requestsSalesHelp: false,
            }
        },
        validations: {
           user: {
               firstName:   { required },
               lastName:    { required },
               email:       { required, email },
               phone:       { required },
               password:    {
                   required,
                   minLength: minLength(8),
                   hasUppercase,
                   hasDigit,
                   hasNonAlphanumeric,
               },
           },
           company: {
              name: { required }
           }
        },
        components: {
            StepIndicator,
            Modal,
        },
        computed: {
            transitionType(){
                return this.showCompanyForm ? 'slide-left' : 'slide-right';
            },
            passwordMsgMap(){
                return { ...this.validatorMsgMapBase,
                    minLength: 'Must be at least 8 Characters'};
            },
        },
        methods: {
            clearFormData(){
               this.user    = defaultUser();
               this.company = defaultCompany();
            },
            signup(){
                this.$v.user.$touch();
                this.$v.company.$touch();
                if (this.$v.user.$invalid || this.$v.company.$invalid ){
                    if (this.$v.company.$invalid) this.showCompanyForm = true; // nav slider to company inputs
                    if (!this.$v.company.$invalid && this.$v.user.$invalid) this.showCompanyForm = false;

                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'See Validation Errors', type: 'error' });
                    return;
                }

                let data = {
                    FirstName:        this.user.firstName,
                    LastName:         this.user.lastName,
                    MobilePhone:      this.user.phone,
                    Email:            this.user.email,
                    Password:         this.user.password,
                    CompanyName:      this.company.name,
                    Website:          this.company.website,
                    AddressLine1:     this.company.addr1,
                    AddressLine2:     this.company.addr2,
                    City:             this.company.city,
                    StateProvinceId:  this.company.stateId,
                    Zip:              this.company.zip,
                };

                SignupService.create(data).then(res => {
                    this.clearFormData();
                    this.$refs.signupConfirmationModal.toggle();
                }).catch(err => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message, type: 'error' });
                });
            }
        }
    }

    function defaultUser(){
        return {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            password: '',
        }
    }

    function defaultCompany() {
        return {
            name: '',
            code: '',
            website: '',
            addr1: '',
            addr2: '',
            city: '',
            stateId: null,
            zip: '',
        }
    }
</script>

<style scoped lang="scss">
    .step-wrapper {
        width: 400px;
    }

    .slide-left-leave-active,
    .slide-left-enter-active,
    .slide-right-leave-active,
    .slide-right-enter-active {
        transition: 1s;
    }

    .slide-left-enter {
        transform: translate(100%, 0);
    }

    .slide-left-leave-to {
        transform: translate(-100%, 0);
    }

    .slide-right-enter {
        transform: translate(-100%, 0);
    }

    .slide-right-leave-to {
        transform: translate(100%, 0);
    }

    .slider-transition {
        overflow: hidden;
        position: relative;
        height: 400px;
        width: 450px;

        .step {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right:0;
            padding: 7px;
        }
    }

    .signup {
        min-height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .card {
            max-width: 500px;
            min-width: 350px;
        }

        .terms-wrapper {
            text-align: center;
            font-size: .8rem;
        }
    }
</style>
